import React, { useState } from "react";
import { reverseDate } from "../../../utils/commonFunctions";
import EstimateIndexPage from "../../../components/Scheduling/UserView";
import UserJobSummery from "../../../components/Scheduling/viewPages/UserJobSummary";
import FullScreenDialog from "../../../components/commons/FullScreenDilog/FullScreenDilog";
import { SCHEDULING_ESTIMATE_JOB_OPTIONS } from "../../../constant/scheduling";
import { oneTimeEstimateDataInput } from "../../../components/Scheduling/UserView/EstimateJob/JobEstimateTab";
import moment from "moment";
import { useLocation } from "react-router-dom";

type AppProps = {
  token: string | null;
  modal: boolean;
  toggleModal: () => void;
  showSchedulingEstimateData?: any;
  jobTypeId?: string;
  selectedClient?: any;
  setShowSchedulingEstimateModal: any;
  showSchedulingEstimateModal: any;
  estimatedJobFunction?: any;
  handleLable?: string | undefined;
  reEstimateDataList?: any;
  handleupdateAction?: any;
  getAction?: any;
  history?: any;
  update?: string | undefined;
  sendForApproval?: boolean;
  dispatchAddSchedulingEstimateAction: (data: any) => void;
  setHandleLable?: any;
  activeTab?: string;
  success: number | null;
};

const EstimateJobUserView = ({
  token,
  modal,
  reEstimateDataList,
  toggleModal,
  showSchedulingEstimateData,
  jobTypeId,
  estimatedJobFunction,
  selectedClient,
  setShowSchedulingEstimateModal,
  showSchedulingEstimateModal,
  handleLable,
  handleupdateAction,
  getAction,
  history,
  update,
  sendForApproval,
  activeTab,
  dispatchAddSchedulingEstimateAction,
  setHandleLable,
  success,
}: AppProps) => {
  const { pathname } = useLocation();
  const [manager, setManager] = useState<any>({
    value: null,
    label: "Select ",
  });
  const [jobData, setJobData] = useState(
    SCHEDULING_ESTIMATE_JOB_OPTIONS[0]?.id
  );
  const [dateRange, setDateRange] = useState<any>([]);
  const [sendApproval, setSendApproval] = useState<boolean>(true);
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const [oneTimeEstimateData, setOneTimeEstimateData] = useState(
    JSON.parse(JSON.stringify(oneTimeEstimateDataInput))
  );
  const [disable, setDisable] = useState(true);
  const onClose = () => {
    if (pathname === "/scheduling/users") {
      history.push({
        pathname: "/scheduling/user",
        state: activeTab,
      });
    }
    setShowSchedulingEstimateModal(!showSchedulingEstimateModal);
    setHandleLable && setHandleLable("");
  };

  const handleAddEstimateData = () => {
    let data = jobData == "oneTime" ? oneTimeEstimateData : dateRange;

    let estimate = data?.map((e: any) => {
      return {
        date:
          e.date && jobData == "oneTime"
            ? reverseDate(e.date)
            : moment(e.date).format("DD-MM-YYYY"),
        hours: e.hours ? e.hours : 0,
      };
    });

    if (reEstimateDataList?.user_id) {
      let finalData = {
        token,
        client_code: reEstimateDataList?.client_code
          ? reEstimateDataList?.client_code
          : selectedClient,
        user_id: reEstimateDataList?.user_id,
        job_id: showSchedulingEstimateData?.job_id
          ? showSchedulingEstimateData?.job_id
          : null,
        future_job_id: !showSchedulingEstimateData?.job_id
          ? showSchedulingEstimateData?.future_job?.future_job_id
            ? showSchedulingEstimateData?.future_job?.future_job_id
            : showSchedulingEstimateData?.future_job
            ? showSchedulingEstimateData?.future_job
            : !showSchedulingEstimateData?.future_job &&
              showSchedulingEstimateData?._id
            ? showSchedulingEstimateData?._id
            : null
          : null,
        manager_id: manager?.value,
        estimation_type: jobData == "oneTime" ? 1 : 2,
        estimation_start_date:
          jobData == "oneTime" ? null : moment(startDate).format("DD-MM-YYYY"),
        estimation_end_date:
          jobData == "oneTime" ? null : moment(endDate).format("DD-MM-YYYY"),
        estimate,
      };

      dispatchAddSchedulingEstimateAction(finalData);
    } else {
      let finalData = {
        token,
        client_code: selectedClient || showSchedulingEstimateData?.client_code,
        job_id: showSchedulingEstimateData?.job_id
          ? showSchedulingEstimateData?.job_id
          : null,
        future_job_id: !(
          showSchedulingEstimateData?.job_id && showSchedulingEstimateData?._id
        )
          ? showSchedulingEstimateData?._id
          : null,
        manager_id: manager?.value,
        estimation_type: jobData == "oneTime" ? 1 : 2,
        estimation_start_date:
          jobData == "oneTime" ? null : moment(startDate).format("DD-MM-YYYY"),
        estimation_end_date:
          jobData == "oneTime" ? null : moment(endDate).format("DD-MM-YYYY"),
        estimate,
      };
      dispatchAddSchedulingEstimateAction(finalData);
    }
  };

  const handleRejectData = () => {
    if (showSchedulingEstimateData?.action) {
      handleupdateAction(showSchedulingEstimateData?.action, "reject");
    } else {
      handleupdateAction(showSchedulingEstimateData?._id, "reject");
    }
  };

  const jobBody = () => {
    return (
      <div>
        <UserJobSummery
          data={showSchedulingEstimateData}
          update={update}
          header={[
            "jobIdType",

            "description",
            "client",
            update ? "estimateBy" : "",
            "startDate",

            "targetEndDate",
            "scheduleStatus",

            "CurrentlyResposible",
            update ? "totalHours" : "",
            "PreviousEstimation",
          ]}
        />
        <div className="d-flex mb-3 mt-4">
          <div
            className={`row ${
              getAction === "reject" ? "col-md-12" : "col-md-10"
            } pl-0`}
          >
            <div
              style={{
                minWidth: getAction === "reject" ? "100%" : "95%",
                marginLeft: "20px",
              }}
            >
              <EstimateIndexPage
                showSchedulingEstimateData={showSchedulingEstimateData}
                reEstimateDataList={reEstimateDataList}
                selectedClient={selectedClient}
                showSchedulingEstimateModal={showSchedulingEstimateModal}
                setShowSchedulingEstimateModal={setShowSchedulingEstimateModal}
                estimatedJobFunction={estimatedJobFunction}
                handleLable={handleLable}
                handleupdateAction={handleupdateAction}
                getAction={getAction}
                history={history}
                update={update}
                sendForApproval={sendForApproval}
                onClose={onClose}
                manager={manager}
                setManager={setManager}
                dateRange={dateRange}
                setDateRange={setDateRange}
                jobData={jobData}
                setJobData={setJobData}
                sendApproval={sendApproval}
                setSendApproval={setSendApproval}
                oneTimeEstimateData={oneTimeEstimateData}
                setOneTimeEstimateData={setOneTimeEstimateData}
                handleAddEstimateData={handleAddEstimateData}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                setDisable={setDisable}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div>
      <FullScreenDialog
        pathname={pathname}
        success={success}
        onClose={onClose}
        manager={manager}
        showSchedulingEstimateData={showSchedulingEstimateData}
        title={
          update && update
            ? "Update Estimate"
            : showSchedulingEstimateData?.schedule_status == 2 ||
              showSchedulingEstimateData?.schedule_status == 3
            ? "Re-Estimate This Job"
            : "Estimate This Job"
        }
        body={jobBody}
        disabled={
          getAction !== "reject" &&
          (!manager?.value ||
            (jobData == "daily" && dateRange?.length == 0) ||
            disable ||
            (showSchedulingEstimateData?.schedule_status == 2 && update) ||
            (!update &&
              !getAction &&
              showSchedulingEstimateData?.schedule_status === 1))
        }
        saveBtn={
          getAction === "reject"
            ? "Reject Request"
            : update
            ? "Approve"
            : "Send for Approval"
        }
        onSubmit={
          getAction === "reject" ? handleRejectData : handleAddEstimateData
        }
      />
    </div>
  );
};

export default EstimateJobUserView;
